import moment from "moment-timezone";

export const fetchScheduleData = async (payload) => {

  //configured api url
  const apiUrl = global.config.routingServiceUrl + `/v1/schedules/${payload.date}/routes`;

  const body = {
    "origin": payload.origin,
    "destination": payload.destination,
    "service_level": payload.serviceLevel,
    "departure_time": payload.departureTime
  };

  let shipDate;

  let originFacility = payload.nonRevAndRevFacilities.find(facility => {
    return facility.airportCodeIATA === payload.origin;
  });

  let destFacility = payload.nonRevAndRevFacilities.find(facility => {
    return facility.airportCodeIATA === payload.destination;
  });

  if (payload.departOrArrive === "depart") {
    shipDate = moment.tz(payload.date + "T" + payload.time, originFacility.olsonTimeZone);
    body.shipDate = shipDate.format();
    body.departureDate = payload.date;
    body.departure_time = payload.time.substring(0, 5);
  } else {
    shipDate = moment.tz(payload.date + "T00:00:00", originFacility.olsonTimeZone);

    let pickUpDate = moment.tz(payload.date + "T" + payload.time, destFacility.olsonTimeZone);

    shipDate = moment(shipDate).isAfter(pickUpDate) ? pickUpDate : shipDate;

    body.shipDate = shipDate.format();
    body.pickUpDate = pickUpDate.format();
    body.departureDate = payload.date;
    body.departure_time = payload.time.substring(0, 5);
  }
  const response = await fetch(apiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  });

  if (!response.ok) {
    throw new Error(response.statusText);
  }

  const data = await response.json();
    return {
        unrestricted_routes: data.unrestricted_routes.map(route => ({
            segments: {
                segment: route.path_flights.map(flight => ({
                    ...flight,
                    scheduledDepartureDate: flight.scheduled_departure_datetime_local,
                    scheduledArrivalDate: flight.scheduled_arrival_datetime_local,
                    estimatedDepartureDate: flight.operational_departure_datetime_local,
                    estimatedArrivalDate: flight.operational_arrival_datetime_local,
                    flightNumber: flight.flight_number,
                    originTimeZone: flight.origin,
                    destinationTimeZone: flight.destination
                }))
            },
            routeTransitTime: route.score && route.score.transit_time_score ? route.score.transit_time_score : 0,
            noOfConnections: route.path.length - 1,
            index: route.path.join('-')
        })),
        segmentTypes: data.segmentTypes || []
    };
};



// WEBPACK FOOTER //
// ./src/api/scheduleDataApi.js